import Vue from 'vue';
import axios from 'axios';

export default {
  name: 'offline',
  props: {
    fetchingData: {
      default: false,
      type: Boolean
    }
  },
  data: function () {
    return {
      //showProgress: false,
    }
  },
  computed: {
    showProgress: function () {
      return this.fetchingData && this.$store.state.csAppsOfflineMode;
    }
  },
  created() {
    
  },
  methods: {
    
  },
}

